const words = {
  parking: {
    es: {
      singular: 'parqueadero',
      plural: 'parqueaderos',
    },
  },
  room: {
    es: {
      singular: 'alcoba',
      plural: 'alcobas',
    },
  },
  bathroom: {
    es: {
      singular: 'baño',
      plural: 'baños',
    },
  },
};

export function getSingularPluralWord(
  key: keyof typeof words,
  quantity: number
) {
  if (quantity === 1) return words[key].es.singular;
  return words[key].es.plural;
}
